module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.woff2
// module id = ../../../../../src/assets/MaterialIcons/iconfont/MaterialIcons-Regular.woff2
// module chunks = styles